module.exports = __webpack_public_path__ + "static/media/infoJumbo4.c7b219a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/aalbers/images/infoJumbo4.jpg
// module id = 592
// module chunks = 0